/* dashboard-rediseno (15-oct-2026): EL ESTILO DE VENTANA DE LA SECCION H.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   "Estilo de ventana": en computadora y tablet, centrada, 440 px, fondo #161616, borde
   #2A2A2A, radio 20, relleno 24, sobre negro al 66 %. En el telefono (abajo de 768, el corte de
   hoy), hoja desde abajo a lo ancho, radio 24 arriba, con agarradera, botones a lo ancho de
   48 px y el principal ARRIBA; si es mas alta que la pantalla, se desplaza por dentro y los
   botones quedan fijos abajo.

   La usan Rename (H1) y borrar un documento dividido (B5). Va en un portal al `body` (una capa
   fija dentro de la lista quedaria atada a la tarjeta). Esc y el toque en el fondo cierran; al
   cerrar, el foco vuelve a `volverA` (el boton que la abrio).

   `botones` es una lista en el orden de la computadora (Cancel y luego el principal); en el
   telefono se pinta al reves para que el principal quede arriba.

   marca-1 (#726): la hoja entra y sale como las del alumno y cierra al bajar la agarradera (`useHojaDeLaCasa`). */
import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useHojaDeLaCasa, FilaDeAgarradera, ENTRA_EL_VELO, ENTRA_LA_CAJA } from '../alumno/arrastreDeHoja';

export const FONDO_DE_LA_VENTANA = 'fixed inset-0 z-[70] flex items-end md:items-center justify-center bg-black/[0.66]';
export const CAJA_DE_LA_VENTANA = 'w-full md:max-w-[440px] max-h-[90dvh] flex flex-col bg-[#161616] border border-[#2A2A2A] rounded-t-[24px] md:rounded-[20px] shadow-2xl';

export default function VentanaDelPanel({ titulo, children, botones, alCerrar, volverA, testid, etiquetaId }) {
  // El cierre se lee de una ref: quien la monta puede pasar una funcion nueva en cada render
  // sin que la ventana suelte y vuelva a tomar el teclado (ni devuelva el foco a media vida).
  const cerrarRef = useRef(alCerrar);
  cerrarRef.current = alCerrar;
  const volverRef = useRef(volverA);
  const hoja = useHojaDeLaCasa(alCerrar);
  useEffect(() => {
    const tecla = (e) => { if (e.key === 'Escape') cerrarRef.current(); };
    document.addEventListener('keydown', tecla);
    const volver = volverRef.current;
    return () => {
      document.removeEventListener('keydown', tecla);
      const b = volver && volver.current;
      if (b && typeof b.focus === 'function') b.focus();
    };
  }, []);

  return createPortal(
    <div ref={hoja.veloRef} className={`${FONDO_DE_LA_VENTANA} ${ENTRA_EL_VELO}`} onClick={(e) => { e.stopPropagation(); if (e.target === e.currentTarget) alCerrar(); }}
      data-testid={testid ? `${testid}-fondo` : undefined}>
      <div ref={hoja.cajaRef} role="dialog" aria-modal="true" aria-labelledby={etiquetaId}
        className={`${CAJA_DE_LA_VENTANA} ${ENTRA_LA_CAJA}`} onClick={(e) => e.stopPropagation()} data-testid={testid}>
        <FilaDeAgarradera agarradera={hoja.agarradera} testid={testid ? `${testid}-agarradera` : undefined} />
        <div className="flex-1 min-h-0 overflow-y-auto px-6 pt-4 md:pt-6 max-md:overscroll-contain max-md:touch-pan-y">
          <h2 id={etiquetaId} className="text-[17px] font-semibold text-[#F4F4F3] break-words">{titulo}</h2>
          <div className="mt-3">{children}</div>
        </div>
        <div className="shrink-0 px-6 pt-4 pb-[max(1.5rem,env(safe-area-inset-bottom))] md:pb-6 flex flex-col-reverse md:flex-row md:justify-end gap-2">
          {botones}
        </div>
      </div>
    </div>,
    document.body,
  );
}

// Los botones de la ventana: 48 a lo ancho en el telefono, 40 desde 768.
export const BOTON_VENTANA = 'h-12 md:h-10 w-full md:w-auto px-4 rounded-xl text-[14px] font-semibold inline-flex items-center justify-center gap-1.5 disabled:opacity-45 disabled:cursor-not-allowed';
export const BOTON_VENTANA_SECUNDARIO = `${BOTON_VENTANA} bg-[#1B1B1B] border border-[#2C2C2C] text-[#F4F4F3]`;
export const BOTON_VENTANA_PRINCIPAL = `${BOTON_VENTANA} bg-[#F27A2E] text-[#160A02]`;
export const BOTON_VENTANA_BORRAR = `${BOTON_VENTANA} bg-[#DC2626] text-white`;
